module.exports = __webpack_public_path__ + "static/media/send-backward.c9efc10d.svg";